import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PagesURLs } from '../pages.url';
import { ErrorsURLs } from '../../errors/errors.url';
import { PasswordRecoveryService, EnvironmentService } from '../../services';
import {
  EnvironmentDataResponse,
  TokenDataResponse,
  ErrorsResponse,
  SessionError,
  ApplicationError,
  ServerError,
  UserData,
  DataResponse,
  LogData
} from '../../models';
import { AppSession } from 'src/app/models/app-session';


@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit {

  private expiredKey = 'exp';
  private tokenKey = 'token';
  private emailKey = 'email';
  private languageKey = 'l';
  private captchaKey = 'captcha';
  private defaultLanguage = 'en';

  @Input() private tokenParam: string;
  @Input() private emailParam: string;
  @Input() private languageParam: string;
  @Input() private captchaParam: string;
  @Input() private expiredParam: string;

  constructor(
    public translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private environmentService: EnvironmentService,
    private passwordRecoveryService: PasswordRecoveryService,
    private userData: UserData
  ) { }

  ngOnInit() {

    this.tokenParam = this.activatedRoute.snapshot.queryParamMap.get(this.tokenKey);
    console.log('Password recovery token: ', this.tokenParam);
    this.emailParam = this.activatedRoute.snapshot.queryParamMap.get(this.emailKey);
    console.log('Password recovery email token: ', this.emailParam);
    this.languageParam = this.activatedRoute.snapshot.queryParamMap.get(this.languageKey);
    console.log('Language param: ', this.languageParam);
    this.captchaParam = this.activatedRoute.snapshot.queryParamMap.get(this.captchaKey);
    console.log('Captcha param: ', this.captchaParam);
    this.expiredParam = this.activatedRoute.snapshot.queryParamMap.get(this.expiredKey);
    console.log('Expired param: ', this.expiredParam);

    if (this.captchaParam != null && this.captchaParam === 'no') {
      AppSession.setCaptchaConfig(this.captchaParam);
    }
    else {
      AppSession.setCaptchaConfig('yes');
    }

    console.log('Navigator lang: ' + navigator.language);
    const navigatorFullLang = (navigator.language).split('-');
    const navigatorLang = navigatorFullLang[0];
    try {
      if (this.languageParam != null) {
        const languageParamCode = this.convertLanguage(this.languageParam);
        this.translate.use(languageParamCode);
        this.userData.language = languageParamCode;
      }
      else {
        this.translate.use(navigatorLang);
        this.userData.language = navigatorLang;
      }
    }
    catch {
      this.translate.use(this.defaultLanguage);
      this.userData.language = this.defaultLanguage;
    }

    try {
      this.environmentService.getEnvironment().subscribe(
        (response: EnvironmentDataResponse) => {
          console.log(response);
          AppSession.setAppPath(response.appPath);
          AppSession.setGRecaptchaSiteKey(response.gRecaptchaSiteKey);
          AppSession.setPasswordPolicy(response.passwordPolicy);
          // AppSession.setEnviroment(response.environment);
          // AppSession.setAmContext(response.amContex);
          AppSession.setEndPoints(response.endPoints);
          AppSession.setLogKeys(response.logKeys);
          this.routeTo();
        },
        (error: ErrorsResponse) => {
          // route to app error
          // console.log(error);
          this.router.navigate([ErrorsURLs.REQUEST_FAILED], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        }
      );
    }
    catch {
      this.router.navigate([ErrorsURLs.REQUEST_FAILED], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
    }
  }

  private convertLanguage(input: string) {
    return (input === 'l01' || input === '01') ? 'ca' : (input === 'l02' || input === '02') ? 'es' : (input === 'l03' || input === '03') ? 'en' : input;
  }

  private routeTo() {
    if (this.tokenParam) {
      this.checkToken();
    }
    else {
      if (this.expiredParam != null) {
        AppSession.setExpired(this.expiredParam === 'yes' ? '1' : '0');
      }
      this.log('', AppSession.getLogKeys().logKey0, '', '');
      this.router.navigate([PagesURLs.IDENTIFICATION], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
    }
  }

  private checkToken() {
    this.log(LogData.logidenttypeMail, AppSession.getLogKeys().logKey5, this.tokenParam, this.emailParam);
    try {
      this.passwordRecoveryService.validateTokenRequest(this.tokenParam)
        .subscribe(
          (response: TokenDataResponse) => {
            console.log(response.data);
            this.userData.username = response.data[0].username;
            this.userData.name = response.data[0].name;
            this.userData.firstName = response.data[0].firstName;
            this.userData.lastName = response.data[0].lastName;
            this.userData.tokensession = response.data[0].tokensession;
            console.log('userData after token validation');
            console.log(this.userData);
            if (this.userData.username !== '' && this.userData.tokensession !== '') {
              this.router.navigate(
                [PagesURLs.CHANGE_PASSWORD], { relativeTo: this.activatedRoute.root, skipLocationChange: true }
              );
            }
          },
          (error: Error) => {
            this.processError(error);
          }
        );
    }
    catch (error) {
      // console.error(error.name);
      this.router.navigate([ErrorsURLs.REQUEST_FAILED], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
    }
  }

  private log(identityType: string, keyLog: string, param0: string, param1: string) {
    try {
      console.log(keyLog + ':' + param0 + ':' + param1);
      this.passwordRecoveryService.log(identityType, keyLog, param0, param1).subscribe((response: DataResponse) => {
        console.log('passwordRecoveryService.log response: ' + response);
      });
    }
    catch (error) {
      console.error(keyLog + ' could not be logged');
      console.error(error);
    }
  }

  private processError(error: Error) {
    switch (error.constructor) {
      case SessionError: {
        // console.warn(error.name);
        this.router.navigate([ErrorsURLs.INVALID_SESSION], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
      case ApplicationError: {
        // console.warn(error.name);
        this.router.navigate([ErrorsURLs.INVALID_TOKEN], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
      case ServerError: {
        // console.error(error.name);
        this.router.navigate([ErrorsURLs.REQUEST_FAILED], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
      default: {
        // console.error(error.name);
        this.router.navigate([ErrorsURLs.REQUEST_FAILED], { relativeTo: this.activatedRoute.root, skipLocationChange: true });
        break;
      }
    }
  }
}
